import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit {

  List: any[] = [
    { title: 'LOCATION_TITLE', icon: 'ion ion-ios-location' , desc: 'Joseph-von-Fraunhofer Str. 20, 44227 Dortmund'},
    { title: 'EMAIL', icon: 'ion ion-ios-email' , desc: 'info@it2in.de'},
    { title: 'PHONE_NUMBER', icon: 'ion ion-ios-telephone' , desc: '02319700382'},
  ]
  constructor() { }

  ngOnInit(): void {
  }
}